import DownloadIcon from '@mui/icons-material/Download';
import { ReactElement } from 'react';
import { Button, useListContext } from 'react-admin';
import type { ClickResource } from '../../../Entities/Click';
import { useClickExport } from './Provider';

export default function ExportAllButton(): ReactElement {
  const { filter, filterValues, isPending, sort, total } = useListContext<ClickResource>();
  const { isRunning, startExport } = useClickExport();

  const handleClick = (): void => {
    const mergedFilter = filter ? { ...filterValues, ...filter } : filterValues;
    void startExport({
      filter: mergedFilter,
      sort,
    });
  };

  return (
    <Button
      label="Export All"
      disabled={isPending || isRunning || total === 0}
      onClick={handleClick}
    >
      <DownloadIcon />
    </Button>
  );
}
